/**
 * Email-format check ported verbatim from the legacy widget's login view (`/\S+@\S+\.\S+/`).
 * Kept as a standalone pure function so it is unit-testable without rendering the form.
 */
export const isValidEmailFormat = (email: string): boolean => /\S+@\S+\.\S+/.test(email);
